import { render, staticRenderFns } from "./NoLayout.vue?vue&type=template&id=42d6a0c3"
import script from "./NoLayout.vue?vue&type=script&lang=js"
export * from "./NoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports